import styled from 'styled-components';
import { Color } from '../../../common/view/color/color';
import { FontSize, LineHeight } from '../../../common/view/font';
import { CssFuncs } from '../../../foundation/css/css.funcs';
import { CentralDragAndDropStyle } from '../app/drag-and-drop/central-drag-and-drop.style';
import { NodeItemStyle } from './node-item.style';

const Container = styled.div.withConfig({
  componentId: 'node-item-self_container',
  displayName: 'NodeItemSelf.Container',
})`
  border-radius: 5px;
  padding: 8px;

  ${CssFuncs.css.asAbsoluteContainer()}

  transition: background-color 0.1s linear, opacity 0.1s linear;

  ${NodeItemStyle.Container}.focused,
  ${CentralDragAndDropStyle.Container}.${CentralDragAndDropStyle.ContainerClassNames.isNotDragging} &:hover {
    background-color: ${Color.alpha.white2};
  }

  &.is-dragging-over-child {
    background-color: #004e9d;
  }

  ${NodeItemStyle.Container}.is-placeholder.not-focused &:not(:hover) {
    opacity: 0;
  }
`;

const Text = styled.div.withConfig({
  componentId: 'node-item-self_text',
  displayName: 'NodeItemSelf.Text',
})`
  & div {
    font-size: ${FontSize.l2};
    line-height: ${LineHeight.size2};
    ${CssFuncs.css.margin({
      top: `${((16 * (LineHeight.size2 - 1)) / 2) * -1}px`,
    })}
    color: ${Color.white2};
  }
  ${NodeItemStyle.Container}.done & div {
    opacity: 0.3;
  }
`;

const Placeholder = styled.div.withConfig({
  componentId: 'node-item-self_placeholder',
  displayName: 'NodeItemSelf.Placeholder',
})`
  ${CssFuncs.css.absolute({
    top: '0px',
    left: '0px',
  })}

  ${CssFuncs.css.padding({
    left: '5px',
  })}

  font-size: ${FontSize.l2};
  line-height: ${LineHeight.size2};
  ${CssFuncs.css.margin({
    top: `${((16 * (LineHeight.size2 - 1)) / 2) * -1}px`,
  })}

  transition: color 0.1s linear;

  color: ${Color.alpha.white7};

  ${CssFuncs.css.eventPassThrough()}

  ${CentralDragAndDropStyle.Container}.${CentralDragAndDropStyle.ContainerClassNames.isDragging} & {
    display: none;
  }
`;

const Actions = styled.div.withConfig({
  componentId: 'node-item-self_actions',
  displayName: 'NodeItemSelf.Actions',
})`
  ${CssFuncs.css.absolute({
    top: '0px',
    right: '0px',
  })}

  padding: 5px;

  ${NodeItemStyle.Container}.focused & {
    display: none;
  }

  ${CentralDragAndDropStyle.Container}.${CentralDragAndDropStyle.ContainerClassNames.isDragging} & {
    display: none;
  }

  ${Container}:hover & {
    backdrop-filter: blur(8px);
    background-color: ${Color.alpha.black1};
    border-radius: 4px;
  }
`;

const ActionButton = styled.div.withConfig({
  componentId: 'node-item-self_action-button',
  displayName: 'NodeItemSelf.ActionButton',
})`
  transition: opacity 0.1s linear;
  opacity: 0;
  ${Container}:hover & {
    opacity: 1;
  }
`;

const ToggleButton = styled.div.withConfig({
  componentId: 'node-item-self_toggle-button',
  displayName: 'NodeItemSelf.ToggleButton',
})`
  transition: opacity 0.1s linear;
  opacity: 0;

  ${Container}:hover & {
    opacity: 1;
  }

  ${NodeItemStyle.Container}:not(.disable-today-visual-holding) &.selected {
    opacity: 1;
  }

  color: ${Color.white7};

  &.selected {
    color: #ffd52c;
  }
`;

const Anchor = styled.div.withConfig({
  componentId: 'node-item-self_anchor',
  displayName: 'NodeItemSelf.Anchor',
})`
  ${CssFuncs.css.absolute({
    left: '0px',
    top: '0px',
  })}
  ${CssFuncs.css.size({ xy: '0px' })}
`;

const LeftButton = styled.div.withConfig({
  componentId: 'node-item-self_left-button',
  displayName: 'NodeItemSelf.LeftButton',
})`
  ${CssFuncs.css.absolute({
    top: '5px',
    right: '1px',
  })}

  transition: opacity 0.1s linear;
  opacity: 0;

  ${Container}:hover & {
    opacity: 1;
  }

  ${CentralDragAndDropStyle.Container}.${CentralDragAndDropStyle.ContainerClassNames.isDragging} & {
    opacity: 0;
  }
`;

export const NodeItemSelfStyle = {
  Container,
  Text,
  Placeholder,
  Actions,
  ActionButton,
  ToggleButton,
  Anchor,
  LeftButton,
};
